import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CertificateListService, externalImageLinks, ProfileService, URLS } from '@core';
import { TranslateService } from '@ngx-translate/core';
import { NotificationsService } from 'angular2-notifications';
import { API_ResponseStatus } from 'src/app/core/config/api-response.config';
import { BrowserStorageKeys } from 'src/app/core/config/browser-storage-keys.config';
import { StorageService } from 'src/app/core/services/storage/storage.service';

@Component({
    selector: 'app-institution-detail',
    templateUrl: './institution-detail.component.html',
    styleUrls: ['./institution-detail.component.less'],
    standalone: false
})
export class InstitutionDetailComponent implements OnInit {
  institutionDetailForm!: FormGroup;
  showForm: boolean = false;
  loading: boolean = false;
  toggleSwitchDescritpion: string = "PROFILE.INSTITUTION-DETAIL.TOGGLE_SWITCH_DESCRIPTION";
  countries: any;
  institution_detail: any = {};

  externalLinks =externalImageLinks;
  urls = URLS;

  constructor(
    private formBuilder: FormBuilder,
    private notify: NotificationsService,
    private certificateService: CertificateListService,
    private storageSrv: StorageService,
    private profileSrv: ProfileService,
    private translate: TranslateService
  ) { 
    this.countries  = this.certificateService.getLocalStorageCountry("ALL");
  }

  ngOnInit(): void {
    this.buildInstitutionDetailForm();
    this.getInstitutionDetail();
  }

  buildInstitutionDetailForm() {
    this.institutionDetailForm = this.formBuilder.group({
      address: [null, [Validators.required]],
      resident_country: [null, [Validators.required]],
      description: [null],
      allow_public_use_of_email: [false],
      user_id: [null, [Validators.required]]
    })
  }

  getInstitutionDetail() {
    this.loading = true;
    this.profileSrv
      .getUser()
      .then((res) => {  
        this.loading = false;
        if (res?.status === API_ResponseStatus.FAILED || !res?.data) return;

        const { id, institution_detail } = res.data;
        this.institution_detail = institution_detail;
        this.institutionDetailForm.patchValue({
          user_id: id,
          address: institution_detail?.address,
          description: institution_detail?.description,
          resident_country: institution_detail?.resident_country,
          allow_public_use_of_email: institution_detail?.allow_public_use_of_email
        })
        // this.showForm = true;

      })
  }

  checkValidity(): Boolean {
    let isValid: boolean = false;
    this.institutionDetailForm.get('address')?.markAsDirty();
    this.institutionDetailForm.get('description')?.markAsDirty();
    this.institutionDetailForm.get('resident_country')?.markAsDirty();
    this.institutionDetailForm.get('allow_public_use_of_email')?.markAsDirty();

    this.institutionDetailForm.get('address')?.updateValueAndValidity();
    this.institutionDetailForm.get('description')?.updateValueAndValidity();
    this.institutionDetailForm.get('resident_country')?.updateValueAndValidity();
    this.institutionDetailForm.get('allow_public_use_of_email')?.updateValueAndValidity();

    if (
      this.institutionDetailForm.get('address')?.valid &&
      this.institutionDetailForm.get('description')?.valid &&
      this.institutionDetailForm.get('resident_country')?.valid &&
      this.institutionDetailForm.get('allow_public_use_of_email')?.valid
    ) {
      isValid = true;
    }

    return isValid;
  }

  updateToken() {
    const token = this.storageSrv.getLocalStorageItem(BrowserStorageKeys.token);
    const institution_detail = this.institution_detail;

    institution_detail['address'] = this.institutionDetailForm.value.address;
    institution_detail['description'] = this.institutionDetailForm.value.description;
    institution_detail['resident_country'] = this.institutionDetailForm.value.resident_country;
    institution_detail['allow_public_use_of_email'] = this.institutionDetailForm.value.allow_public_use_of_email;
    token['institution_detail'] = institution_detail;
    
    this.storageSrv.setLocalStorageItem(BrowserStorageKeys.token, token)    
  }
  
  submitForm() {
    if (this.checkValidity() == false) return;    
    this.profileSrv
      .updateInsitutionBiodata(this.institutionDetailForm.value)
      .then((res: any) => {
        this.loading = false;
        this.notify.success('', res?.message);
        this.updateToken();
      })
      .catch((err: any) => {
        this.notify.error('', err?.error?.message)
        this.loading = false;
      })
  }

  showEditForm() {
    this.showForm = true;
  }

  hideEditForm() {
    this.showForm = false;
  }

}